import {Link} from "preact-router/match";

declare var STATIC_BASE_URL:string;
declare var BASE_URL:string;

import '../styles/forbes.scss';
import '../styles/forbesproducts.scss';

import { h, Component } from 'preact';

export default class Forbes extends Component<any, any> {

    constructor() {
        super();
    }

    public render (props, state): any {
      
      const calltoaction = <p class="center calltoaction">
        <a href="mailto:info@querlo.com?subject=Forbes insights solutions | Request a demo" class="butt huge">Request a demo</a>
      </p>;

        return <div id="forbesleadinsights" class="forbes">
          <section class="full withBackground" style={{backgroundImage: "url(" + STATIC_BASE_URL + 'images/public/forbes-hr-assistant-top.jpg' + ")"}}>
            
                <div class="titleWrp">
                  <h1>Forbes Insights Solutions</h1>
                  <h2>Connecting your firm with c-suite decision makers</h2>
                  <div class="logoWrp">
                    <img alt="Forbes Insights" class="logo" src={ STATIC_BASE_URL + 'images/public/forbes-insight_big@2x.png' } />
                    <div>AI solutions powered by Querlo</div>
                  </div>
                </div>
  
                { calltoaction }
                
              
            
          </section>
          <div class="mainWrp">
            <section>
              <div class="cols">
                <div class="col">
                    <h2>Lead Insights</h2>
                    <h3>DIRECT EMAIL OUTREACH TO YOUR PROSPECTS</h3>
                    <p>
                      To support your campaign, Forbes Insights will engage in direct email and social media outreach using Conversational AI technology with customized questions and conversations to gather proprietary insights. This can be combined with Forbes Lead Generation service.
                    </p>
                    <h4>Lead Insights Provided:</h4>
                    <ul>
                      <li>Insights and perspectives</li>
                      <li>Comments</li>
                      <li>Sentiment and emotions</li>
                      <li>Company stage in the journey</li>
                    </ul>
                </div>
        
                <div class="col">
                  <img alt="Forbes Insights" src={ STATIC_BASE_URL + 'images/public/forbes-insight-leadscomputer.jpg' } />
                </div>
      
              </div>
            </section>
          </div>
          <div class="mainWrp">
            <section>
              <div class="cols">
                <div class="col">
                  <h2>Benefit of AI in Lead Insights</h2>
                  <h3>We work closely with partners to drive success</h3>
                  <p>The use of Artificial Intelligence improves the quality and the quantity of engagements. AI also provides faster MQLs (marketing qualified leads) that lead to better SQLs (sales qualified leads) and then Conversions.</p>
                  <h4>Providing:</h4>
                  <ul>
                    <li>
                      Higher engagement level
                    </li>
                    <li>
                      Reduced time to conversion to MQL (marketing qualified lead)
                    </li>
                    <li>
                      Better proprietary insights and datasets
                    </li>
                  </ul>
                </div>
                  <div class="col">
                    <img alt="Forbes Insights" src={ STATIC_BASE_URL + 'images/public/forbes-insight-brain.jpg' } />
                  </div>
              </div>
            </section>
          </div>
          <div class="mainWrp">
            <section>
              <div class="cols">
                <div class="col">
                  <h2>Lead Gen</h2>
                  <h3>LEVERAGE PROGRAM CONTENT FOR MQLs</h3>
                  <p>
                    Drive actionable results for your marketing ROI with a strategic, turnkey and customized B2B lead generation campaign.  Leveraging program content Forbes will execute a turnkey campaign that includes:
                  </p>
                  <ul>
                    <li>Email outreach to a pre-qualified, receptive audience</li>
                    <li>
                      A campaign that is customized to your target audience based on:
                      <ul>
                        <li>Industry</li>
                        <li>Company size or company names</li>
                        <li>Job title by seniority and function</li>
                        <li>Geographic location</li>
                      </ul>
                    </li>
                    <li>A guaranteed number of leads* delivered via XLS or custom API (additional fees may apply) with complete list of names, companies, titles and email addresses delivered upon end of campaign
                    </li>
                  </ul>
                  <p class="note">*All program leads will be MQL unless otherwise scoped; leads will have opted in to receive further marketing communications from you</p>
                  <p>NOTE: Costs vary based on lead demographics, campaign timing, etc...</p>
                </div>
                <div class="col">
                  <img alt="Forbes Insights" src={ STATIC_BASE_URL + 'images/public/forbes-insight-leadgenimg.jpg' } />
                </div>
              </div>
            </section>
          </div>
          <div class="mainWrp">
            <section id="specialColumnsWrp">
              <h2>Lead Gen User Journey</h2>
              <h3>PRE-QUALIFIED <span>+</span> RECEPTIVE AUDIENCE <span>=</span> SEAMLESS CUSTOMER EXPERIENCE</h3>
              <div class="columnsofcolumns">
                <div class="columnofcolumn">
                  <h4>Audience Universe</h4>
                  <div class="columnsWrp">
                    <div class="column">
                      <div class="imgWrp">
                        <img src={ STATIC_BASE_URL + 'images/public/icons/forbesinsight-audience.png' } />
                      </div>
                      Audience selection details + suppression list shared with Forbes and any ABM lists
                    </div>
                    <div class="column">
                      <div class="imgWrp">
                        <img src={ STATIC_BASE_URL + 'images/public/icons/forbesinsight-leads.png' } />
                      </div>
                      Estimated number of leads supplied<br/>
                      <span class="note">Note that this number is estimated based on database of B2B audiences who have consented to receive content that may be of interest to them</span>
  
                    </div>
                  </div>
                </div>
  
                <div class="columnofcolumn">
                  <h4>Campaign Preparation</h4>
                  <div class="columnsWrp">
                    <div class="column">
                      <div class="imgWrp">
                        <img src={ STATIC_BASE_URL + 'images/public/icons/forbesinsight-docs.png' } />
                      </div>
                      Creative asset agreed upon
                    </div>
                    <div class="column">
                      <div class="imgWrp">
                        <img src={ STATIC_BASE_URL + 'images/public/icons/forbesinsight-mail.png' } />
                      </div>
                      Copy to generate interest in the creative asset is developed and shared with client for sign-off
                    </div>
                  </div>
                </div>
  
                <div class="columnofcolumn">
                  <h4>Deployment & Delivery</h4>
                  <div class="columnsWrp">
                    <div class="column">
                      <div class="imgWrp">
                        <img src={ STATIC_BASE_URL + 'images/public/icons/forbesinsight-computerpng.png' } />
                      </div>
                      Email is deployed to target audience<br />
                      Recipients are able to directly download the creative asset from the email<br />
                      Creative asset is not gated as recipient’s info is already on file
                    </div>
                    <div class="column">
                      <div class="imgWrp">
                        <img src={ STATIC_BASE_URL + 'images/public/icons/forbesinsight-address.png' } />
                      </div>
                      Complete list of recipients who viewed and/or downloaded the creative asset is supplied to client as a MQL.
                    </div>
                  </div>
                </div>
                
              </div>
              <p class="note">*Please note, Forbes is not responsible for the leads preference towards the partner or likeliness to buy products or services.
              </p>
            </section>
          </div>
          <section class="full grey">
            { calltoaction }
          </section>
        </div>
    }
}


// WEBPACK FOOTER //
// ./ts/Forbesleadinsights.tsx